import { useInfiniteQuery } from "@tanstack/react-query";
import client from "@/api/client";
import { useFlattenInfiniteData } from "@/hooks/useFlattenInfiniteData";
import { ConversationDto } from "@/api/sdk";
import { useAuth } from "@/providers/authContext";
import { useChatStore } from "@/stores/useChatStore";
import { useMemo } from "react";
export const CONVERSATIONS_QUERY_KEY = ["infinite-conversations-query"] as const;

interface ConversationsResponse {
  items: ConversationDto[];
  total: number;
}

const useInfiniteConversationsQuery = () => {
  const { bearerToken } = useAuth()
  const take = 30;
  const { searchConversation } = useChatStore()

  const query = useInfiniteQuery({
    queryKey: [...CONVERSATIONS_QUERY_KEY, searchConversation],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await client.api.aiAgentControllerGetConversations({
        limit: take,
        offset: pageParam * take,
        search: searchConversation,
      });
      return response.data as ConversationsResponse;
    },
    initialPageParam: 0,
    staleTime: 1000 * 60 * 1,
    enabled: !!bearerToken,
    getNextPageParam: (lastPage, pages) => {
      return lastPage.items?.length < take ? undefined : pages.length;
    },
  });

  const [flattenedConversations, total] = useFlattenInfiniteData(query.data, {
    flattenFn: (data: ConversationsResponse) => data.items,
    totalFn: (data: ConversationsResponse) => data.total,
  });

  return {
    ...query,
    data: flattenedConversations,
    total,
  };
}

export default useInfiniteConversationsQuery;